import React, { Component, Fragment, useContext, useState } from "react";
import { Button, Popup, Icon } from "semantic-ui-react";
import { ObjChooser } from "../ObjChooser";
import iiiflogo from "../../../../assets/images/iiif_logo.png";
import { checkObjectOwner } from "./helpers";
import { deleteObject } from "../../../search/helpers";
import AnnotationToggleButton from "../../../annotation/components/Annotation/AnnotationToggleButton";
import PropTypes from "prop-types";
import { SearcherContext } from "../../../search/components/SearcherContext";
import { NextButton, PrevButton } from "../../../navigation/components/Buttons";
import EditAnnotationButton from "../../../annotation/components/Annotation/EditAnnotationButton";
import { isAnnotatable } from "../../../annotation/helpers";
import HelpModal from "../../../help/components/HelpModal";
import * as config from "../../../../config";

const ObjectManagementControls = ({ obj, history, doSearch }) => {
  const search = useContext(SearcherContext);
  return (
    <div style={{ display: "inline-block" }}>
      <Button
        compact
        onClick={() => {
          const yesno = window.confirm(
            "Do you REALLY want to delete this object?"
          );
          if (yesno) {
            deleteObject(obj, search.credentials.token, result =>
              setTimeout(() => doSearch(), 500)
            );
          }
        }}
      >
        Delete
      </Button>
      <Button
        compact
        onClick={() => {
          history.push(
            `${process.env.REACT_APP_URL_PATH}/cerl/pda/edit/${obj.ID[0]}`
          );
        }}
      >
        Edit
      </Button>
    </div>
  );
};

const IIIFLogo = ({ obj }) => (
  <a
    style={{ margin: "0 1em 0 0" }}
    target="mirador"
    href={
      obj.URL_IIIF_MANIFEST
        ? `/mirador.html?manifest=${obj.URL_IIIF_MANIFEST[0]}`
        : `${process.env.REACT_APP_IIIF_SERVER}/${
            obj.ALLIMAGES[0]
          }/info.json`
    }
  >
    <img src={iiiflogo} className="iiif-logo" alt="IIIF" />
  </a>
);

export const SearchNavigation = ({ obj, history, section }) => (
  <Fragment>
    {obj._searchPrevious && (
      <PrevButton
        size="small"
        onClick={() =>
          history.push(
            `${process.env.REACT_APP_URL_PATH}/view/${
              obj._searchPrevious[0]
            }/${section}`
          )
        }
      />
    )}
    <Button
      size="small"
      title="Back to search results"
      onClick={() =>
        history.push(`${process.env.REACT_APP_URL_PATH}/section/${section}`)
      }
    >
      <Button.Content visible>
        <Icon name="home" />
      </Button.Content>
    </Button>
    {obj._searchNext && (
      <NextButton
        size="small"
        onClick={() =>
          history.push(
            `${process.env.REACT_APP_URL_PATH}/view/${
              obj._searchNext[0]
            }/${section}`
          )
        }
      />
    )}
  </Fragment>
);

const handleSetOriginalCLick = url =>
  window.open(url, `${process.env.REACT_APP_PROJECT_NAME}_Original`);

// navigational component for all 'default' object renderings
const DefaultNavigation = ({ position, obj, ...props }) => {
  // eslint-disable-next-line
  const [_, setFoo] = useState(Math.random());
  return (
    <Fragment>
      {obj.ALLIMAGES[0] && <IIIFLogo obj={obj} />}

      {checkObjectOwner(obj, props.search.credentials) && (
        <ObjectManagementControls
          history={props.history}
          obj={obj}
          doSearch={props.doSearch}
        />
      )}

      {obj.ALLIMAGES[0] && (
        <Popup trigger={<Button compact content="Image URL" />} on="click">
          {obj.ALLIMAGES.map(animage => (
            <p key={animage}>{`${window.location.protocol}//${
              window.location.hostname
            }${process.env.REACT_APP_URL_PATH}/f/${animage}`}</p>
          ))}
        </Popup>
      )}

      {!props.search.savedObjects[obj.ID[0]] && (
        <Button
          color="teal"
          compact
          onClick={event => {
            props.search.addSavedItem(obj);
            setFoo(Math.random());
          }}
        >
          Save
        </Button>
      )}
      {obj.URL_WEBPAGE && (
        <Button
          compact
          color="olive"
          onClick={event => handleSetOriginalCLick(obj.URL_WEBPAGE[0])}
        >
          Original Source
        </Button>
      )}
      {obj.LINK_FACSIMILE && (
        <Button
          compact
          onClick={event =>
            handleSetOriginalCLick(
              `${process.env.REACT_APP_URL_PATH}/view/${
                obj.LINK_FACSIMILE[0].ID[0]
              }/${props.section}`
            )
          }
        >
          Facsimile
        </Button>
      )}
      {obj.LINK &&
        obj.LINK.map(link => (
          <Popup
            trigger={
              <Button
                compact
                content="Link"
                onClick={event =>
                  handleSetOriginalCLick(
                    `${process.env.REACT_APP_URL_PATH}/view/${link}/${
                      props.section
                    }`
                  )
                }
              />
            }
            content={link}
          />
        ))}

      {isAnnotatable(obj) && <AnnotationToggleButton />}
      {isAnnotatable(obj) && props.search.credentials && (
        <EditAnnotationButton />
      )}

      {obj.PARENT && (
        <Button
          compact
          onClick={() =>
            props.history.push(
              `${process.env.REACT_APP_URL_PATH}/view/${obj.PARENT[0]}/${
                props.section
              }`
            )
          }
        >
          Container
        </Button>
      )}

      <Popup
        trigger={
          <Button
            color="violet"
            compact
            content="Persistent URL"
            floated="right"
          />
        }
        on="click"
      >
        <p>{`${window.location.protocol}//${window.location.hostname}${
          process.env.REACT_APP_URL_PATH
        }/view/${obj.ID[0]}/${props.section}`}</p>
      </Popup>
      <HelpModal />
    </Fragment>
  );
};

export class Default extends Component {
  getChildContext() {
    return { obj: this.props.obj };
  }

  render() {
    return (
      <div>
        {(config.OBJECT_CTA_POSITION || "top") === "top" && (
          <DefaultNavigation {...this.props} />
        )}
        {ObjChooser(
          this.props.obj,
          this.props.section,
          this.props.search,
          this.props.history
        )}
        {(config.OBJECT_CTA_POSITION || "top") === "bottom" && (
          <DefaultNavigation {...this.props} />
        )}
      </div>
    );
  }
}

Default.childContextTypes = {
  obj: PropTypes.object
};
